import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
   const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling effect
    });
  };
  return (
    <footer className="site-footer pbmit-bg-color-secondary">
      <div className="pbmit-footer-big-area-wrapper">
        <div className="pbmit-footer-big-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12 col-xl-6 pbmit-footer-left">
                <h3>Subscribe for latest <br /> updates & insights</h3>
              </div>
              <div className="col-md-12 col-xl-6">
                <form>
                  <div className="pbmit-footer-newsletter">
                    <div className="pbmit-news-wrap">
                      <input
                        type="email"
                        className="form-control"
                        name="EMAIL"
                        placeholder="Enter Your Email Address"
                      />
                      <button className="pbmit-btn">
                        <span className="pbmit-button-content-wrapper">
                          <span className="pbmit-button-text">Subscribe Now</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="pbmit-footer-widget-area">
          <div className="container">
            <div className="row">
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget">
                  <div className="pbmit-footer-logo">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`}
                      style={{ width: "125px" }}
                    
                      alt="Logo"
                    />

                  </div>
                  <br />
                  <ul className="pbmit-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a title="Facebook" href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a title="Twitter" href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a title="LinkedIn" href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a title="Instagram" href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </aside>
              </div>
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget">
                  <h2 className="widget-title">Say Hello</h2>
                  <div className="pbmit-contact-widget-lines">
                    <div className="pbmit-contact-widget-line pbmit-base-icon-phone">713-275-8786</div>
                    {/* <div className="pbmit-contact-widget-line pbmit-base-icon-email">
                      <a href="mailto:[email&#160;protected]">[email&#160;protected]</a>
                    </div> */}
                  </div>
                </aside>
              </div>
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget">
                  <h2 className="widget-title">Ship With Us</h2>
                  <ul className="menu">
                    <li><Link to="/drayage">Drayage</Link></li>
                    <li><Link to="/warehousing">Warehousing </Link></li>
                    <li><Link to="/over-the-road">Over The Road</Link></li>
                    <li><Link to="/intermodal">Intermodal</Link></li>
                    <li><Link to="/flatbed">Flatbed</Link></li>
                    <li><Link to="/reefer">Reefer</Link></li>
                    <li><Link to="/ltl">LTL</Link></li>
                    <li><Link to="/cross-border">Cross Border Logistics</Link></li>
                  </ul>
                </aside>
              </div>
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget">
                  <h2 className="widget-title">Industries</h2>
                  <ul className="menu">
                    <li><Link to="/automotive">Automotive</Link></li>
                    <li><Link to="/food-beverage">Food & Beverage</Link></li>
                    <li><Link to="/produce">Produce</Link></li>
                    <li><Link to="/renewable-energy">Renewable Energy</Link></li>
                    <li><Link to="/retail">Retail</Link></li>
                    <li><Link to="/manufacturing">Manufacturing</Link></li>
                    <li><Link to="/building-materials">Building Materials</Link></li>
                    <li><Link to="/oil-gas-energy">Oil & Gas Energy</Link></li>
                    <li><Link to="/healthcare-pharma">Healthcare & Pharma</Link></li>
                    <li><Link to="/government-defense">Government & Defense</Link></li>
                  </ul>
                </aside>
              </div>
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget">
                  <h2 className="widget-title">Quick Nav</h2>
                  <ul className="menu">
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/services">Service</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                  
                  </ul>
                </aside>
              </div>
              <div className="pbmit-footer-widget-col-0 col-md-2">
                <aside className="widget widget_text">
                  <h2 className="widget-title">Legals</h2>
                  <ul className="menu">
                    {/* <li><a href="#">Terms</a></li> */}
                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    <li><Link to="/licensing-info">Licensing info</Link></li>
                    {/* <li><a href="#">Certifications & Associations</a></li> */}

                  </ul>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <div className="pbmit-footer-text-area">
          <div className="container">
            <div className="pbmit-footer-text-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="pbmit-footer-copyright-text-area">
                    Copyright © 2025 <a href="#"> TRACKLINE XR</a>, All Rights Reserved.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="pbmit-backtotop" onClick={scrollToTop} style={{cursor:"pointer"}}>
        <div className="pbmit-arrow">
          <i className="pbmit-base-icon-plane"></i>
        </div>
        <div className="pbmit-hover-arrow">
          <i className="pbmit-base-icon-plane"></i>
        </div>
      </div>
    </footer>
    

  );
};
export default Footer;